export enum InstallationView {
  Computers = 'computers',
  HyperV = 'hyper-v',
  Rmm = 'rmm'
}
